<template src="./header.html"></template>
<script>
import Vue from 'vue'
import AlertContainer from '@/components/header/alert-container/AlertContainer.vue'
import { logout, getUserName } from '@/router/auth.js'
import securityStore from '@/store/security-store'
import { EventBus } from '@/router/bus'

export default {
  data () {
    return {
      environment: process.env.NODE_ENV,
      username: '',
      registrationAllowed: Vue.$config.registration_allowed,
      logout: logout
    }
  },
  methods: {
    loginMulti () {
      this.$router.push('/login')
    },
    sideIconClickHandle () {
      this.$emit('toolbarSideIconClick')
    }
  },
  components: {
    AlertContainer
  },
  computed: {
    isAuth () {
      return securityStore.getters.isAuth
    }
  },
  created () {
    if (this.isAuth) {
      this.username = getUserName()
    }
    EventBus.$on('logged-in', () => {
      this.username = getUserName()
    })
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
@import "~@/assets/scss/variables.scss";

.heavier-text {
  font-weight: 600;
}

a {
  color: white;
  text-decoration: none;
}

.toolbar-button {
  text-transform: none !important;
  font-weight: 600;
}

.toolbar-button-item {
  text-transform: none !important;
  font-weight: 600;
  font-size: 12pt;
  pointer-events: none;
}

.selected-toolbar-button {
   background-color: #429a86;
}
</style>
